import React from "react";
import { Link } from "@fluentui/react-components";

interface NewformaLinkProps {
    className?: string;
    onClick?: React.MouseEventHandler<HTMLAnchorElement & HTMLSpanElement>;
    disabled?: boolean;
    title?: string;
    children?: React.ReactNode;
    dataTestId?: string;
    style?: React.CSSProperties;
}

export const NewformaLink: React.FC<NewformaLinkProps> = ({
    className,
    onClick,
    disabled,
    title,
    children,
    dataTestId,
    style,
}) => {
    return (
        <Link
            className={className}
            onClick={onClick}
            disabled={disabled}
            title={title}
            data-testid={dataTestId}
            style={style}
        >
            {children}
        </Link>
    );
};
